import { Toolbar, AppBar, Box, IconButton } from "@mui/material";
import { ConsortiumMemberBadge } from "@/features/consortiumBadge/ConsortiumMemberBadge";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { HeaderMenu } from "./components/HeaderMenu";
import { OrderButton } from "./components/OrderButton";
import { ManualInfoButton } from "./components/ManualInfoButton";
import logo from "../../assets/logo_color.svg";
import { BookListButton } from "./components/BookListButton";
import { useFeatureFlags } from "@/configs/featureFlag";
import { OwnerInfoAnalyzeButton } from "./components/OwnerInfoAnalyzeButton";
import { CommercialBookListButton } from "./components/CommercialBookListButton";
import { CustomerManagementLink } from "./components/CustomerManagementLink";
import { EmailManagementLink } from "./components/EmailManagementLink";
import { ContactButton } from "./components/ContactButton";
import { UpdateButton } from "@/features/header/components/UpdateButton";
import { HEADER_HEIGHT } from "@/features/header";
import { useSideMenuState } from "@/hooks/useSideMenuState";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import {
  MONTHLY_MEMBER_BADGE_LABEL,
  BrandBadge,
  useIsMonthlyMember,
} from "@/features/brandBadge";

const HeaderPresenter: React.FC = () => {
  const {
    customerManagement,
    commercialBookList,
    ownerInfoList,
    emailManagement,
    mypageTop,
  } = useFeatureFlags();
  const { isMobileOpen, toggleMobileMenu } = useSideMenuState();
  const currentUser = useCurrentUser();
  const isMonthlyMember = useIsMonthlyMember();

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "white.main",
        borderBottom: "1px solid",
        borderColor: "border.main",
        boxShadow: "none",
        zIndex: 1100,
        height: HEADER_HEIGHT,
      }}
    >
      <Toolbar
        sx={{
          minHeight: HEADER_HEIGHT,
          height: HEADER_HEIGHT,
          px: { xs: "8px", md: 2 },
        }}
      >
        {/* スマホ時のみハンバーガー/閉じるメニュー表示 */}
        <IconButton
          onClick={toggleMobileMenu}
          sx={{
            display: { xs: "flex", md: "none" },
            mr: 1,
            color: "darkgray.main",
          }}
          aria-label={isMobileOpen ? "メニューを閉じる" : "メニューを開く"}
        >
          {isMobileOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
        <Box sx={{ mr: "auto" }}>
          <Link to={mypageTop ? "/mypage" : "/feed"}>
            <img
              src={logo}
              alt="logo"
              height="20px"
              style={{ display: "block" }}
            />
          </Link>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {!mypageTop && customerManagement && <CustomerManagementLink />}
          {!mypageTop && emailManagement && <EmailManagementLink />}
          {!mypageTop && <BookListButton />}
          {!mypageTop && ownerInfoList && <OwnerInfoAnalyzeButton />}
          {!mypageTop && commercialBookList && <CommercialBookListButton />}

          {!mypageTop && <ContactButton />}
          {!mypageTop && <OrderButton />}
          {!mypageTop && <ManualInfoButton />}
          {/* コンソーシアム会員バッジ: 所属クライアントが共同コンソーシアム企業のときのみ表示 */}
          {currentUser?.isConsortiumMember === true && (
            <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
              <ConsortiumMemberBadge size="small" />
            </Box>
          )}
          {/* 月額会員のときのみ、アカウントメニューの左に上品なゴールドバッジを控えめに表示。
              狭幅では折りたたみ（email 表示と同様 xs では非表示）。 */}
          {isMonthlyMember && (
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                mr: 1,
              }}
            >
              <BrandBadge label={MONTHLY_MEMBER_BADGE_LABEL} size="small" />
            </Box>
          )}
          <HeaderMenu />
          <UpdateButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export { HeaderPresenter };
